import { useLang } from 'hooks/lang';

import { invoiceStatusConfig } from 'entities';

import { InvoiceByStatus } from './InvoiceByStatus';

import { formatCurrency } from 'utils/text';
import { sortByCurrency } from '../sorters';

export function Paid(): JSX.Element {
  const { t } = useLang();

  return (
    <>
      <InvoiceByStatus
        status={invoiceStatusConfig.paid.code}
        allowMultiSelection={false}
        columns={[
          {
            label: t('client-name') as string,
            property: 'clientName',
            filter: true,
            sort: true,
          },
          {
            label: t('type') as string,
            property: 'type',
            filter: true,
          },
          {
            label: `${t('invoice')} #`,
            property: 'accountantId',
            search: true,
          },
          {
            label: t('value') as string,
            render: ({ value, currency }) => formatCurrency(value, currency),
            getTextValue: ({ currency }) => currency,
            filter: true,
            sort: true,
            sorter: sortByCurrency,
          },
          {
            label: t('paid-value') as string,
            render: ({ valuePaid, currency }) => formatCurrency(valuePaid as string, currency),
            getTextValue: ({ currency }) => currency,
            filter: true,
          },
        ]}
      />
    </>
  );
}
